module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsMessage":"No pages to show."},"fi":{"noItemsMessage":"Sivuja ei löytynyt."}}')
  delete Component.options._Ctor
}
